import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useModal from "components/modal/useModal";
import UseContext from "hooks/useContext";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import MissionTemplateSummary from "pages/missionTemplates/components/MissionTemplateSummary";
import { Pencil } from "assets/icons";

const PreviewMissionTemplate = () => {
    const navigate = useNavigate();
    const { toggle } = useModal();
    const {
        previewMissionTemplate,
        setPreviewMissionTemplate,
        setSelectedMissionTemplate,
        setPage,
    } = UseContext();

    const t = previewMissionTemplate;

    const close = () => {
        setPreviewMissionTemplate(null);
        toggle();
    };

    const handleModifier = () => {
        if (!t?._id) {
            close();
            return;
        }
        navigate(`/missionTemplates/edit/${t._id}`);
        setPreviewMissionTemplate(null);
        toggle();
    };

    const handleUtiliser = () => {
        if (!t?._id) {
            close();
            return;
        }
        if (t.isBelowMinimumWage) {
            toast.error(
                "Cette fiche est inférieure au SMIC, mettez-la à jour avant utilisation."
            );
            return;
        }
        setSelectedMissionTemplate(t);
        setPage(3);
        navigate("/createOfMission");
        setPreviewMissionTemplate(null);
        toggle();
    };

    const title =
        t?.name || t?.title || "Fiche de poste";

    return (
        <>
            <Modalheader hide={close} hideShow={true}>
                {title}
            </Modalheader>
            <ModalBody>
                <MissionTemplateSummary
                    apiTemplate={t}
                    smicWarning={!!t?.isBelowMinimumWage}
                />
            </ModalBody>
            <ModalFooter>
                <div className="flex w-full flex-wrap items-center justify-between gap-4">
                    <Button
                        size={"LG"}
                        color={"SECONDARY"}
                        onClick={handleModifier}
                        disabled={!t?._id}
                    >
                        <span className="inline-flex items-center gap-2">
                            <Pencil wh={18} color="#4B5563" />
                            Modifier
                        </span>
                    </Button>
                    <div className="flex flex-wrap items-center justify-end gap-4">
                        <Button size={"LG"} color={"SECONDARY"} onClick={close}>
                            Annuler
                        </Button>
                        <Button
                            size={"LG"}
                            color={"PRIMARY"}
                            onClick={handleUtiliser}
                            disabled={!t?._id || t?.isBelowMinimumWage}
                        >
                            Utiliser cette fiche
                        </Button>
                    </div>
                </div>
            </ModalFooter>
        </>
    );
};

export default PreviewMissionTemplate;
